// extracted by mini-css-extract-plugin
export default {"graph":"ProfileStatsGraphs_graph__vo8YM","graphItem":"ProfileStatsGraphs_graphItem__Q3NWf","total":"ProfileStatsGraphs_total__7vt07"};